"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withId = /*#__PURE__*/ (0, vue_2.withScopeId)("data-v-93832ed0");
(0, vue_2.pushScopeId)("data-v-93832ed0");
var _hoisted_1 = { style: { "position": "absolute", "inset": "8px", "display": "flex", "flex-direction": "column" } };
var _hoisted_2 = { style: { "display": "flex", "position": "relative", "flex": "1 1 auto" } };
var _hoisted_3 = { style: { "flex": "1 1 auto", "height": "100%", "position": "relative" } };
var _hoisted_4 = /*#__PURE__*/ (0, vue_2.createTextVNode)("增加对比区间");
var _hoisted_5 = /*#__PURE__*/ (0, vue_2.createTextVNode)("查询");
(0, vue_2.popScopeId)();
var element_plus_1 = require("element-plus");
var BureauTagSelector_vue_1 = require("./BureauTagSelector.vue");
var vue_3 = require("vue");
var bureau_1 = require("../../napis/bureau");
var time_1 = require("../../utils/time");
var echarts = require("echarts");
var moment = require("moment");
exports.default = (0, vue_1.defineComponent)({
    expose: [],
    setup: function (__props) {
        var tags = (0, vue_3.ref)();
        var data = (0, vue_3.ref)([]);
        var loading = (0, vue_3.ref)(false);
        var weeks = (0, vue_3.ref)([]);
        function addWeek() {
            var key = Date.now() + "" + Math.random();
            var week;
            if (weeks.value.length > 0) {
                week = moment(weeks.value[weeks.value.length - 1].week).subtract(1, "week").toDate();
            }
            else {
                week = new Date();
            }
            weeks.value.push({ key: key, week: week });
        }
        for (var i = 0; i < 2; i++) {
            addWeek();
        }
        function removeWeek(idx) {
            weeks.value.splice(idx, 1);
        }
        function loadData() {
            return __awaiter(this, void 0, void 0, function () {
                var ts_1, ps, _a;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            loading.value = true;
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, , 3, 4]);
                            ts_1 = tags.value;
                            ps = weeks.value.map(function (d) { return __awaiter(_this, void 0, void 0, function () {
                                var _a, s, e;
                                var _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            _a = (0, time_1.getWeekRange)(d.week), s = _a[0], e = _a[1];
                                            _b = {
                                                week: d.week
                                            };
                                            return [4 /*yield*/, (0, bureau_1.getActiveStudentAccountAmount)(s, e, ts_1)];
                                        case 1: return [2 /*return*/, (_b.data = _c.sent(),
                                                _b)];
                                    }
                                });
                            }); });
                            _a = data;
                            return [4 /*yield*/, Promise.all(ps)];
                        case 2:
                            _a.value = _b.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            loading.value = false;
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        (0, vue_3.watch)([tags], function (_a, _b) {
            var n = _a[0];
            var o = _b[0];
            if (!o && Boolean(n))
                loadData();
        });
        var echartContainer = (0, vue_3.ref)();
        var chart = null;
        function buildSeries(line) {
            var data = line.data, week = line.week;
            if (data.length < 1)
                return;
            var d = data.slice(1);
            return {
                type: "line",
                smooth: true,
                areaStyle: {},
                name: moment(week).startOf("week").format("gggg 年第 ww 周"),
                data: d.map(function (it) { return it.amount; })
            };
        }
        function draw() {
            if (data.value.length < 1)
                return;
            if (!chart) {
                chart = echarts.init(echartContainer.value);
            }
            chart.setOption({
                title: {
                    text: "学生账户活跃统计",
                },
                tooltip: {
                    trigger: 'axis',
                    position: function (pt) {
                        return [pt[0], '10%'];
                    }
                },
                legend: {
                    orient: 'vertical',
                    right: 10,
                    top: 'center'
                },
                xAxis: {
                    data: data.value[0].data.slice(1).map(function (it) { return "".concat(it.days, "\u5929\u767B\u5F55"); })
                },
                yAxis: {},
                series: data.value.map(buildSeries)
            }, { replaceMerge: ['series'] });
            chart.resize();
        }
        (0, vue_3.watch)([data], function () { return draw(); });
        (0, vue_3.onMounted)(function () {
            window.addEventListener("resize", draw);
        });
        (0, vue_3.onBeforeUnmount)(function () { return window.removeEventListener("resize", draw); });
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)("div", _hoisted_2, [
                    (0, vue_2.createVNode)("div", _hoisted_3, [
                        (0, vue_2.createVNode)("div", {
                            ref: echartContainer,
                            class: "echart-container"
                        }, null, 512)
                    ]),
                    (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElDivider), {
                        direction: "vertical",
                        style: { "height": "100%" }
                    }),
                    (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElForm), {
                        "label-width": "80px",
                        style: { "width": "360px", "padding": "8px" },
                        size: "small"
                    }, {
                        default: _withId(function () { return [
                            (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElFormItem), { label: "机构标签" }, {
                                default: _withId(function () { return [
                                    (0, vue_2.createVNode)(BureauTagSelector_vue_1.default, {
                                        modelValue: tags.value,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return (tags.value = $event); })
                                    }, null, 8, ["modelValue"])
                                ]; }),
                                _: 1
                            }),
                            ((0, vue_2.openBlock)(true), (0, vue_2.createBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(weeks.value, function (w, i) {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.unref)(element_plus_1.ElFormItem), {
                                    key: w.key,
                                    label: "\u65F6\u95F4\u533A\u95F4 ".concat(i)
                                }, {
                                    default: _withId(function () { return [
                                        (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElDatePicker), {
                                            modelValue: w.week,
                                            "onUpdate:modelValue": function ($event) { return (w.week = $event); },
                                            type: "week",
                                            "unlink-panels": "",
                                            clearable: false,
                                            format: "gggg 年第 ww 周"
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                        (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElDivider), { direction: "vertical" }),
                                        (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElButton), {
                                            type: "danger",
                                            onClick: function ($event) { return (removeWeek(i)); },
                                            icon: "el-icon-delete",
                                            circle: ""
                                        }, null, 8, ["onClick"])
                                    ]; }),
                                    _: 2
                                }, 1032, ["label"]));
                            }), 128)),
                            (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElFormItem), null, {
                                default: _withId(function () { return [
                                    (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElButton), {
                                        onClick: addWeek,
                                        icon: "el-icon-plus"
                                    }, {
                                        default: _withId(function () { return [
                                            _hoisted_4
                                        ]; }),
                                        _: 1
                                    })
                                ]; }),
                                _: 1
                            }),
                            (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElFormItem), null, {
                                default: _withId(function () { return [
                                    (0, vue_2.createVNode)((0, vue_2.unref)(element_plus_1.ElButton), {
                                        onClick: loadData,
                                        type: "primary",
                                        icon: "el-icon-search",
                                        loading: loading.value
                                    }, {
                                        default: _withId(function () { return [
                                            _hoisted_5
                                        ]; }),
                                        _: 1
                                    }, 8, ["loading"])
                                ]; }),
                                _: 1
                            })
                        ]; }),
                        _: 1
                    })
                ])
            ]));
        };
    }
});
